import React from 'react'
import PropTypes from 'prop-types'
import { Row, Col, Form, FormGroup, Button, ListGroup, ListGroupItem } from 'react-bootstrap'
import { ENGAGEMENTS } from '../../../constants/commons'

export default class MultiSelectAutoSuggest extends React.Component {
  static propTypes = {
    module: PropTypes.string.isRequired,
    data: PropTypes.array,
    selectedValues: PropTypes.array,
    handleSelect: PropTypes.func,
    isOpen: PropTypes.bool,
    tourFinished: PropTypes.bool
  }

  constructor (props) {
    super(props)
    this.state = {
      isOpen: false,
      showData: false
    }
    this.styles = {
      formGroupMargin: {
        marginBottom: '0px'
      }
    }
    this.handleClickOutside = this.handleClickOutside.bind(this)
  }

  componentDidMount () {
    this.setState({ isOpen: this.props.isOpen })
    document.addEventListener('mousedown', this.handleClickOutside)
  }

  componentWillUnmount () {
    // Unbind the event listener on clean up
    document.removeEventListener('mousedown', this.handleClickOutside)
  }

  handleClickOutside (event) {
    if (event && event.target && event.target.className && (typeof event.target.className.indexOf === 'function') && event.target.className.indexOf('inputRef_' + this.props.module) > -1)
   {
      this.setState({
        showData: true,
        isOpen: true
      })
    } else {
      this.setState({
        showData: false,
        isOpen: false
      })
    }
  }

  render () {
    let header = this.props.selectedValues.length === 1 ? this.props.selectedValues[0] : this.props.selectedValues.length > 1 ? 'Multiple' : this.props.module
    header = header === 'National Geographic Channel' ? 'National Geographic' : header
    header = header && header.length > 23 ? header.substring(0, 23) : header
    return (
      <Row className='dropDown'>
        <Col>
          <Form>
            <FormGroup style={this.styles.formGroupMargin}>
              <Button className={this.props.selectedValues.length > 0 ? `inputRef_${this.props.module} librarySelectFilter selectedFilter` : `inputRef_${this.props.module} librarySelectFilter`}>
                {header}
              </Button>
            </FormGroup>
            <EntityList
              module={this.props.module}
              data={this.props.data}
              showData={this.state.showData}
              handleSelect={this.props.handleSelect}
              selectedValues={this.props.selectedValues}
              isOpen={this.state.isOpen}
            />
          </Form>
        </Col>
      </Row>
    )
  }
}

class EntityList extends React.Component {
  static propTypes = {
    module: PropTypes.string.isRequired,
    data: PropTypes.array,
    selectedValues: PropTypes.array,
    showData: PropTypes.bool,
    handleSelect: PropTypes.func,
    isOpen: PropTypes.bool
  }

  constructor (props) {
    super(props)

    this.state = {
      values: []
    }

    this.styles = {
      listItem: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
      },
      listGroupItem: {
        padding: '5px 10px'
      },
      checkboxMargin: {
        marginTop: '0px',
        marginBottom: '0px',
        marginRight: '5px'
      },
      checkboxAndTitle: {
        display: 'flex',
        alignItems: 'center'
      },
      optionAndTitle: {
        display: 'flex'
      },
      optionAndTitleSpan: {
        paddingLeft: '8px'
      },
      otherDefaultEntity: {
        marginRight: '15px'
      }
    }
  }

  componentDidMount () {
    this.setState({ values: this.props.selectedValues })
  }

  componentDidUpdate (prevProps) {
    if (prevProps.selectedValues !== this.props.selectedValues && this.props.selectedValues) {
      this.setState({ values: this.props.selectedValues })
    }
  }

  handleSelect = (value) => {
    let values = this.state.values
    let exists = values.find(e => e === value)
    if (exists) {
      values = values.filter(e => e !== value)
    } else {
      values = values.concat([value])
    }
    this.setState({ values: values })
    this.props.handleSelect(values)
  }

  render () {
    let values = []
    const data = this.props.data || []
    const inputRef = 'inputRef_' + this.props.module
    const entitiesListStyle = {
      position: 'absolute',
      zIndex: this.props.showData ? '99' : '0',
      width: '100%',
      height: 'calc(100vh - 200px)',
      overflow: 'auto',
      padding: '0px'
    }
    return (
      <Col style={entitiesListStyle} className={this.props.module === ENGAGEMENTS ? 'dropdownStyle' : ''}>
        <ListGroup className='cursorPointer'>
          { (this.props.showData || this.props.isOpen) && data && data.map((d, index) => {
            values = this.state.values.filter(e => e === d)
            return (
              <ListGroupItem key={`${d}_${index}`} style={this.styles.listGroupItem} className={inputRef} onClick={() => this.handleSelect(d)}>
                <span style={this.styles.listItem} className={inputRef}>
                  <span style={this.styles.checkboxAndTitle} className={inputRef}>
                    <input type='checkbox' className={`${inputRef} cursorPointer`} style={this.styles.checkboxMargin}
                      id={`${index}_${d}`}
                      checked={values.length > 0}
                      value={d}
                      onChange={() => this.handleSelect(d)} />
                    <span className={`${inputRef} cursorPointer`} htmlFor={`${index}_${d}`}>{d}</span>
                  </span>
                </span>
              </ListGroupItem>
            )
          })}
        </ListGroup>
      </Col>
    )
  }
}
